<template>
  <div>
    <menu-pae :inFocus="false" :isVisible="false">
      <template>
        <div id="menuMesagem">
          <div class="acoes">
            <button class="btn btn-danger" @click.prevent="voltar"> Voltar </button>
            <button class="btn btn-primary" @click.prevent="salvar()"> Salvar </button>
          </div>
        </div>
      </template>
    </menu-pae>

    <div class="d-flex justify-content-center">
      <div class="row container">
        <div class="col-md-5 col-sm-12 text-sm-center">
          <nav aria-label="breadcrumb bg-white">
            <ol class="breadcrumb breadcrumb bg-white">
              <li class="breadcrumb-item"><router-link to="/workArea">Home</router-link></li>
              <li class="breadcrumb-item"><router-link to="/workArea/admin">Admin</router-link></li>
              <li class="breadcrumb-item"><router-link to="/estrutura/inativa">Estruturas Inativas</router-link></li>
              <li class="breadcrumb-item active" aria-current="page">Inativar</li>
            </ol>
          </nav>
        </div>
      </div>
    </div>

    <alert-comp :msg="alert" :key="alert.key"/>

    <div class="row">
      <div class="container mt-2">
        <div class="form-group row mt-3">
          <div class="col-12 mb-3">
            <div class="input-group">
              <select class="form-control center-select" v-model="status">
                <option v-for="(item, indice) in tipos" :key="indice" :value="item.value">
                  {{ item.text }}
                </option>
              </select>
            </div>
          </div>
          <label class="col-sm-2 text-sm-right">Sigla Orgão:</label>
          <auto-complete-comp
            :key="autocomplete.key"
            :class="isAtivo ? 'col-md-4 col-sm-10 mb-3' : 'col-sm-9 mb-3'"
            :isAsync="true"
            :url="autocomplete.url"
            :mutation="autocomplete.mutation"
            :keyAttrName="autocomplete.valueAttribute"
            :valueAttrName="autocomplete.textAttribute"
            :valor="{codigoHierarquia: filtro.codigoHierarquia}"
            :params="autoCompleteParams"
            :keyAttrFilter="autocomplete.attrFilter">
          </auto-complete-comp>

          <label v-if="isAtivo" class="col-sm-2 text-sm-right">Sigla Departamento:</label>
          <div v-if="isAtivo" class="col-md-3 col-sm-11 mb-3">
            <input
              type="text"
              class="form-control"
              id="inputDepartamento"
              placeholder="informe o departamento"
              v-model="filtro.siglaEstrutura"
              :disabled="disableDepartamento"
            />
          </div>

          <label v-if="isAtivo" class="col-sm-2 text-sm-right">Descrição Departamento:</label>
          <div v-if="isAtivo" class="col-md-4 col-sm-11 mb-3">
            <input type="text"
                  class="form-control"
                  id="nomeEstrutura"
                  placeholder="informe a descrição do departamento"
                  @change="alterarFiltro"
                  v-model="filtro.nomeEstrutura"
                  :disabled="disableDepartamento"
            >
          </div>

          <label v-if="isAtivo" class="col-sm-2 text-sm-right">Nome Gestor:</label>
          <div v-if="isAtivo" class="col-md-3 col-sm-11 mb-3">
            <input
              type="text"
              class="form-control"
              id="inputGestor"
              placeholder="informe o nome do gestor"
              v-model="filtro.nomeGestor"
              :disabled="disableDepartamento"
            />
          </div>

          <label v-if="isAtivo" class="col-sm-2 text-sm-right">Cidade:</label>
          <div v-if="isAtivo" class="col-md-4 col-sm-11 mb-3">
            <input
              type="text"
              class="form-control"
              id="inputCidade"
              placeholder="informe a cidade"
              v-model="filtro.cidade"
              :disabled="disableDepartamento"
            />
          </div>

          <div class="col-sm-12">
            <div class="row btnAcoes">
              <div class="col-1"></div>
              <button class="btn btn-outline-success" @click.prevent="() => consultar()"> Pesquisar</button>
              <button class="btn btn-outline-danger" @click.prevent="limpar"> Limpar</button>
            </div>
          </div>
        </div>
        <data-table-consulta-comp class="p-2"
          :colNames="table.columns.names"
          :eventBusDataName="table.event.data"
          :eventBusDataPaginationName="table.event.pagination"
          :dataTableColumn="table.columns.attributes">
          <template v-slot="slotProps">
            <td style="text-align: center; width: 100px !important;">
              <i class="fa fa-plus text-success fa-1-5x link" aria-hidden="true"
                v-on:click="salvar(slotProps.itemData)"></i>
            </td>
          </template>
        </data-table-consulta-comp>
      </div>
    </div>
  </div>
</template>

<script>
import md5 from 'md5'
import { mapState } from 'vuex'

import alertComp from '@/components/alert/AlertComp'
import menuPae from '@/components/Menu.vue'
import autoCompleteComp from '@/components/autocomplete/AutoCompleteComp'
import dataTableConsultaComp from '@/components/data-table-consulta/DataTableConsultaComp'

import EstruturaService from '@/services/EstruturaService'
import eventBus from '@/uteis/eventBus'

export default {
  name: 'inativar',

  components: {
    alertComp,
    menuPae,
    autoCompleteComp,
    dataTableConsultaComp
  },

  created () {
    this.service = new EstruturaService()
    this.consultar()
    eventBus.$on(this.table.event.pagination, page => {
      this.consultar(page)
    })
  },

  destroyed () {
    eventBus.$off(this.table.event.data)
    eventBus.$off(this.table.event.pagination)
  },

  data () {
    return {
      alert: {
        texto: '',
        type: '',
        key: true
      },
      tipos: [{
        value: 'ativo',
        text: 'Orgãos Ativos'
      }, {
        value: 'inativo',
        text: 'Orgãos Inativos'
      }],
      status: 'ativo',
      filtro: {
        codHierarquia: null,
        siglaEstrutura: null,
        nomeGestor: null,
        cidade: null,
        idDepartamento: null,
        nomeEstrutura: null,
        status: 3,
        range: 10
      },
      autocomplete: {
        mutation: 'MUT_FILTRO_DESTINATARIO_DEPARTAMENTO',
        key: false,
        valueAttribute: 'codigoHierarquia',
        textAttribute: 'siglaEstrutura',
        url: '/d0593/pae-back/v1/participantes/migracao/estrutura',
        attrFilter: 'siglaorgao'
      },
      table: {
        event: {
          data: 'dataEstrutura',
          pagination: 'paginationEstrutura'
        },
        columns: {
          names: ['Sigla Departamento', 'Sigla Orgão', 'Nome Gestor', 'Data Inativação', 'Ações'],
          attributes: [
            'siglaEstrutura',
            'siglaOrgao',
            'nomeUsuario',
            {
              column: 'dataAlteracao',
              converter: 'localDate'
            }
          ]
        }
      }
    }
  },

  computed: {
    securityKey () {
      const dateNow = new Date()
      return md5(dateNow)
    },
    isAtivo () {
      return this.status === 'ativo'
    },
    autoCompleteParams () {
      return {
        status: this.status === 'ativo' ? 1 : 3
      }
    },
    ...mapState({
      disableDepartamento: state => {
        return !state.filtroDestinatario || !state.filtroDestinatario.codigoHierarquia
      },
      codigoHierarquia: state => state.filtroDestinatario.codigoHierarquia
    })
  },

  watch: {
    autoCompleteParams (newValue, oldValue) {
      if (newValue !== oldValue) {
        this.limpar()
        eventBus.$emit(this.table.event.data, {
          data: [],
          pagination: {
            hasNext: false,
            hasPrev: false,
            pageCount: 1,
            pageNumber: 1,
            totalReg: 0
          },
          id: 'estruturaID'
        })
      }
    }
  },

  methods: {
    voltar () {
      this.$router.back()
    },

    consultar (page = 1) {
      this.filtro = {
        ...this.filtro,
        offset: page,
        codHierarquia: this.codigoHierarquia
      }

      if (!this.isAtivo) {
        const data = {
          ...this.$store.state.filtroDestinatario,
          siglaOrgao: this.$store.state.filtroDestinatario.siglaEstrutura
        }
        eventBus.$emit(this.table.event.data, {
          data: [data],
          pagination: {
            hasNext: false,
            hasPrev: false,
            pageCount: 1,
            pageNumber: 1,
            totalReg: 1
          },
          id: 'estruturaID'
        })
        return
      }

      this.service.buscarDepartamentoInativa(this.filtro).then(res => {
        const departamentos = res.data.data.map((departamento) => {
          return {
            ...departamento,
            siglaOrgao: this.$store.state.filtroDestinatario.siglaEstrutura
          }
        })
        eventBus.$emit(this.table.event.data, {
          data: departamentos,
          pagination: res.data.pagination,
          id: 'estruturaID'
        })
      }).catch(err => {
        console.log(err)
      })
    },

    limpar () {
      this.filtro = {
        ...this.filtro,
        siglaEstrutura: null,
        nomeGestor: null,
        cidade: null,
        nomeEstrutura: null,
        codHierarquia: null
      }

      this.$store.commit('MUT_FILTRO_DESTINATARIO_DEPARTAMENTO', {})
      this.autocomplete.key = !this.autocomplete.key
      this.consultar()
    },

    alterarFiltro () {
      const { codigoHierarquia } = this.$store.state.filtroDestinatario
      this.filtro = { ...this.filtro, codigoHierarquia }
    },

    salvar (data) {
      const dadosSessao = this.$store.getters.getDadosSessao.sessao
      data.participantePai = this.$store.state.filtroDestinatario
      this.service.inativarEstrutura(data, dadosSessao).then(res => {
        this.alert.texto = 'Estrutura foi inativada com sucesso'
        this.alert.type = 'success'
        this.alert.key = !this.alert.key
      }).catch(() => {
        this.alert.texto = 'Aconteceu algum erro ao inativar estrutura'
        this.alert.type = 'warning'
        this.alert.key = !this.alert.key
      })
    }
  }
}
</script>

<style scoped lang="scss">
.acoes {
  display: flex;
  padding: 15px;
  position: absolute;

  .btn {
    margin-right: 10px;
    width: 150px;
    height: 28px;
  }
}

#dadosElaboracaoProcesso div{
  padding-bottom: 2px;
  padding-top: 2px;

  .btnInteressados {
    padding: 3px 18px;
    border-radius: 4px;
  }
}

.btn {
  //padding: 8px 16px;
  border-radius: 5px;
  &--primary {
    background-color: green;
    color: #fff;
  }
  &--secondary {
    background-color: #dddd;
    color: #000;
  }
}

.interesadoResumidos {
  background-color: white;
}

.interessadosHeader {
  display: flex;
  align-items: center;
  justify-content: space-between;
  flex-direction: row;
  padding: .75rem;
  background-color: rgba(213, 228, 251, 1);

  .titulo {
    color: #0962BD;
    margin: 10px;
  }

  i {
    color: red;
  }
}

.interessadosFooter {
  display: flex;
  justify-content: flex-end;

  .btn {
    margin-left: 5px;
    margin-right: 10px;
  }
}

.overflow-hidden {
  overflow: hidden;
}

.erro {
  color: orange;
}
</style>
